import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Connects to data-controller="column-editor-v3"
//
// Simplified column editor for V3 - just handles removal
//
export default class extends Controller {
  static targets = ["item", "destroyField", "lockIcon", "unlockIcon"]

  removeColumn(event) {
    event.preventDefault()
    event.stopPropagation() // Prevent selecting the column when removing

    const columnId = this.element.dataset.columnId

    // Set _destroy field to true
    if (this.hasDestroyFieldTarget) {
      this.destroyFieldTarget.value = 'true'
    }

    // Hide the item
    this.element.style.display = 'none'

    // Notify properties-sidepanel controller to close if this column's properties are open
    const closePanelEvent = new CustomEvent('column-removed', {
      bubbles: true,
      detail: { columnId: columnId }
    })
    this.element.dispatchEvent(closePanelEvent)

    // Notify selected-columns controller to update empty state
    const updateEvent = new CustomEvent('selected-columns:update', {
      bubbles: true,
      detail: { source: 'column-editor-v3', action: 'remove', columnId: columnId }
    })
    this.element.dispatchEvent(updateEvent)

    // Trigger auto-save with the correct event name
    const autoSaveEvent = new CustomEvent('report-autosave:schedule', {
      bubbles: true,
      detail: { source: 'column-editor-v3', action: 'remove', columnId: columnId }
    })
    this.element.dispatchEvent(autoSaveEvent)
  }

  toggleLock(event) {
    event.preventDefault()
    event.stopPropagation() // Prevent selecting the column when toggling lock

    // Find the hidden locked field
    const lockedField = this.element.querySelector('input[data-column-data="locked"]')
    if (!lockedField) {
      logger.log('[Column Editor V3] No locked field found')
      return
    }

    // Toggle the value
    const currentValue = lockedField.value
    const newValue = (currentValue === 'true') ? 'false' : 'true'
    lockedField.value = newValue
    lockedField.setAttribute('value', newValue)

    logger.log(`[Column Editor V3] Toggled lock from ${currentValue} to ${newValue}`)

    // Update the icon visibility
    if (this.hasLockIconTarget && this.hasUnlockIconTarget) {
      const isLocked = newValue === 'true'
      this.lockIconTarget.style.display = isLocked ? '' : 'none'
      this.unlockIconTarget.style.display = isLocked ? 'none' : ''
    }

    // If the properties panel is open for this column, update the toggle there too
    const propertiesPanelToggle = document.querySelector('[data-column-property="locked"]')
    if (propertiesPanelToggle && propertiesPanelToggle.type === 'checkbox') {
      propertiesPanelToggle.checked = (newValue === 'true')
    }

    // Trigger auto-save
    const autoSaveEvent = new CustomEvent('report-autosave:schedule', {
      bubbles: true,
      detail: { source: 'column-editor-v3', action: 'toggle-lock', locked: newValue }
    })
    this.element.dispatchEvent(autoSaveEvent)

    // Dispatch event for locked-cells-warning controller
    const columnId = this.element.dataset.columnId
    const lockedStateChangedEvent = new CustomEvent('column-locked-state-changed', {
      bubbles: true,
      detail: { columnId: columnId, locked: newValue === 'true' }
    })
    this.element.dispatchEvent(lockedStateChangedEvent)
  }
}


